import { sortPoster } from "@/lib/posterTemplate";

const norm = (s) => (s || "").toUpperCase().normalize("NFD").replace(/[^A-Z0-9]/g, "");
const dayOf = (h) => (h || "").trim().split(/\s+/)[0].toUpperCase();
const core = (match, team) => (match || "").toUpperCase().split(" - ").map((x) => x.trim()).filter((x) => norm(x) !== norm(team))
  .join(" ").normalize("NFD").replace(/[^A-Z ]/g, " ").split(/\s+/).filter((w) => w.length >= 4).sort((a, b) => b.length - a.length)[0] || "";

const allRows = (d) => [...(d.top?.rows || []), ...(d.columns || []).flatMap((c) => c.rows || []), ...(d.footer || [])];

export const isDup = (r, existing, team) => {
  const k = core(r.match, team);
  return existing.some((e) => norm(e.cat) === norm(r.cat) && (k ? norm(e.match).includes(norm(k)) || norm(r.match).includes(norm(core(e.match, team)) || "§") : norm(e.match) === norm(r.match)));
};

export const dupIds = (data, parsed) => {
  const ex = allRows(data), team = data.team_name || "USC";
  return [...parsed.top.rows, ...parsed.cols.flatMap((c) => c.rows), ...parsed.footer].filter((r) => isDup(r, ex, team)).map((r) => r.id);
};

export const mergeParsed = (data, parsed, uid) => {
  const strip = (rows) => rows.map(({ home_guess, ...r }) => r);
  const columns = [...(data.columns || [])];
  parsed.cols.forEach((c) => {
    if (!c.rows.length) return;
    const i = columns.findIndex((o) => dayOf(o.header) && dayOf(o.header) === dayOf(c.header));
    const j = i >= 0 ? i : columns.findIndex((o) => !(o.rows || []).length);
    if (j >= 0) columns[j] = { ...columns[j], header: columns[j].header || c.header, rows: [...(columns[j].rows || []), ...strip(c.rows)] };
    else columns.push({ id: uid(), header: c.header, rows: strip(c.rows) });
  });
  const top = parsed.top.rows.length ? { ...(data.top || {}), header: data.top?.header || parsed.top.header, rows: [...(data.top?.rows || []), ...strip(parsed.top.rows)], show: true } : data.top;
  return sortPoster({
    ...data, top, columns,
    footer: [...(data.footer || []), ...strip(parsed.footer)],
    show_columns: true, show_footer: data.show_footer !== false || parsed.footer.length > 0,
  });
};
